import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core";
import {Typography, useTheme, useMediaQuery} from '@material-ui/core';
import {deepOrange, green} from "@material-ui/core/colors";
import {Constants} from "../constants/Constants";

// noinspection JSUnusedLocalSymbols
const useDigitStyle = makeStyles((theme) => ({
    odometerDigit: {
        boxShadow: 'inset 0 0 .3em rgba(0, 0, 0, 0.8)',
        backgroundImage: 'linear-gradient(top, #333 0%, #333 40%, #101010 60%, #333 80%, #333 100%)',
        borderRadius: '.15em',
        paddingLeft: 9,
        paddingRight: 16,
        fontSize: 50,
        fontWeight: 600,
        textAlign: 'center',
        letterSpacing: '.1em',
        transitionTimingFunction: 'linear',
        color: '#111',
        '&:last-child': {
            backgroundImage: 'linear-gradient(top, #eee0d3 0%, #eee0d3 40%, #bbaa9a 60%, #eee0d3 80%, #eee0d3 100%)',
            backgroundColor: '#eee0d3',
            color: '#000'
        }
    },
    odometerDigitWhite: {
        boxShadow: 'inset 0 0 .3em rgba(0, 0, 0, 0.8)',
        backgroundImage: 'linear-gradient(top, #FFF 0%, #FFF 40%, #FFFFFF 60%, #FFF 80%, #FFF 100%)',
        borderRadius: '.15em',
        paddingLeft: 9,
        paddingRight: 16,
        fontSize: 50,
        fontWeight: 600,
        textAlign: 'center',
        letterSpacing: '.1em',
        transitionTimingFunction: 'linear',
    }
}));

export default function LotteryWinningNumbersView(props) {

    const classes = useDigitStyle();
    const {roll, rolled, tickets, ...others} = props;
    const theme = useTheme();
    const inMobileMode = useMediaQuery(theme.breakpoints.down(500));
    const [placeHolders, setPlaceHolders] = useState({0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0});

    const isATicketNumberAmongstTheWinningNumbers = (value) => {
        if (tickets.length === 0) {
            return false
        }
        let inTickets = false;
        for (let ticket of tickets) {
            inTickets = inTickets || ticket.numbers.includes(parseInt(value));
        }
        return inTickets;
    }

    function getNumbers(numberString) {
        return (numberString).split(',').map((n) => (n));
    }

    useEffect(() => {
        if (!rolled) {
            animatePlaceHolders();
        } else {
            clearInterval(parseInt(localStorage.getItem("multiplier_roller_id")))
        }
    }, [rolled]);

    function animatePlaceHolders() {
        let intervalId = setInterval(() => {
            setPlaceHolders({
                0: Math.floor(Math.random() * Constants.BASE_NUMBER),
                1: Math.floor(Math.random() * Constants.BASE_NUMBER),
                2: Math.floor(Math.random() * Constants.BASE_NUMBER),
                3: Math.floor(Math.random() * Constants.BASE_NUMBER),
                4: Math.floor(Math.random() * Constants.BASE_NUMBER),
                5: Math.floor(Math.random() * Constants.BASE_NUMBER),
            });
        }, 1);
        localStorage.setItem("multiplier_roller_id", intervalId + "")
    }

    // noinspection DuplicatedCode
    const values = getNumbers(roll);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            marginBottom: 10,
            width: '75%',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            alignItems: 'center',
        }} {...others}>
            {
                values.map((value, index) => {
                    return <div
                        className={isATicketNumberAmongstTheWinningNumbers(value) ? classes.odometerDigitWhite : classes.odometerDigit}
                        style={{
                            marginTop: 10,
                            width: 50,
                        }}
                        key={index}>
                        <Typography
                            style={{
                                fontStyle: 'bolder',
                                fontWeight: 800,
                                textAlign: 'center',
                                fontSize: inMobileMode ? 30 : 35,
                                color: isATicketNumberAmongstTheWinningNumbers(value) ? green[900] : deepOrange[600]
                            }}>
                            {rolled ? value : placeHolders[index]}
                        </Typography>
                    </div>
                })
            }
        </div>
    );
}
